// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"a2c53fb8","58":"cc9f89aa","134":"018630e8","238":"81edd6b8","453":"64aababc","491":"8e2cd9b9","526":"bfb43cb4","678":"7408eced","682":"06f7c11b","786":"66600dfe","855":"b2d8efa2","894":"cd19de78","912":"dd32d444"}[chunkId] + ".chunk.js";
};